import axiosInstance from '../config/axios';

// ──────────────────────────────────────────────
// Teacher / Mentor APIs
// ──────────────────────────────────────────────

/**
 * Fetch all approved teachers (public - no auth required)
 * @param {{ language?: string }} params
 */
export const getTeachersApi = (params = {}) =>
  axiosInstance.get('/teacher-listing-web', { params, headers: { skipAuthRedirect: true } }).then((res) => res.data);

/**
 * Fetch a single teacher by ID (public deeplink route)
 * @param {string} id
 */
export const getTeacherByIdApi = (id) =>
  axiosInstance.get(`/teacher/${id}`, { headers: { skipAuthRedirect: true } }).then((res) => res.data);

/**
 * Follow a teacher (requires auth)
 * @param {string} followingId 
 */
export const followTeacherApi = (followingId) =>
  axiosInstance.post('/follow', { followingId }).then((res) => res.data);

/**
 * Unfollow a teacher (requires auth)
 * @param {string} followingId 
 */
export const unfollowTeacherApi = (followingId) =>
  axiosInstance.post('/unfollow', { followingId }).then((res) => res.data);

/**
 * Fetch all available languages
 */
export const getLanguagesApi = () =>
  axiosInstance.get('/languages', { headers: { skipAuthRedirect: true } }).then((res) => res.data);

/**
 * Fetch all available countries
 */
export const getCountriesApi = () =>
  axiosInstance.get('/country', { headers: { skipAuthRedirect: true } }).then((res) => res.data);

/**
 * Fetch followers list for a user or teacher
 * @param {string} [userId]
 */
export const getFollowersApi = (userId) =>
  axiosInstance.get('/followers', { params: userId ? { userId } : {} }).then((res) => res.data);

/**
 * Fetch following list for a user or teacher
 * @param {string} [userId]
 */
export const getFollowingApi = (userId) =>
  axiosInstance.get('/following', { params: userId ? { userId } : {} }).then((res) => res.data);

/**
 * Fetch reviews for a teacher
 * @param {string} teacherId
 */
export const getTeacherReviewsApi = (teacherId) =>
  axiosInstance.get('/reviews', { params: { teacherId }, headers: { skipAuthRedirect: true } }).then((res) => res.data);

/**
 * Fetch top followed users (public - website)
 */
export const getTopFollowedUsersApi = () =>
  axiosInstance.get('/top-followed-users').then((res) => res.data);

/**
 * Fetch homepage statistics (public - website)
 */
export const getHomepageStatsApi = () =>
  axiosInstance.get('/homepage-stats').then((res) => res.data);

/**
 * Fetch students list
 * @param {object} params
 */
export const getStudentListingApi = (params = {}) =>
  axiosInstance.get('/student-listing', { params }).then((res) => res.data);

/**
 * Search teachers
 * @param {object} params
 */
export const searchTeachersApi = (params = {}) =>
  axiosInstance.get('/search-teacher', { params }).then((res) => res.data);

/**
 * Rate a teacher
 * @param {{ teacher_id: string, rating: number, comment?: string }} data
 */
export const rateTeacherApi = (data) =>
  axiosInstance.post('/rate-teacher', data).then((res) => res.data);

/**
 * Get teacher rating by ID
 * @param {string} teacherId
 */
export const getTeacherRatingsApi = (teacherId) =>
  axiosInstance.get(`/teachers/${teacherId}/ratings`).then((res) => res.data);

/**
 * Get live teachers listing
 */
export const getLiveTeachersApi = () =>
  axiosInstance.get('/live-teacher-listing').then((res) => res.data);

/**
 * Toggle teacher live status
 * @param {string} id
 * @param {{ isLive: boolean }} data
 */
export const toggleTeacherLiveApi = (id, data) =>
  axiosInstance.patch(`/teacher/${id}/live`, data).then((res) => res.data);


